/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {IconProps} from '../types/types';

/*
 * Defines the Design Language System (DLS) Asset Trailer Icon component.
 */
export const HierarchyIndicatorIcon = (props: IconProps) => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0V13.0667V14V14.0667H14V13.0667H1V0H0Z" fill={dlsColor('grey5')}/>
    </svg>
  );
};
